export default "__VITE_ASSET__DLyAupkD__"